const menuLinks = () => [
	{
		label: 'Start',
		href: '/',
		class: ['nav-item', 'nav-link'],
	},
	{
		label: 'Oferta',
		href: '/oferta',
		class: ['nav-item', 'nav-link'],
	},
	// {
	// 	label: 'O nas',
	// 	href: '/o-nas',
	// 	class: ['nav-item', 'nav-link'],
	// },
	{
		label: 'Kontakt',
		href: '/kontakt',
		class: ['nav-item', 'nav-link'],
	},
]

export { menuLinks }
